import {Inject, Injectable} from "@angular/core";
import {PricingService} from "../pricing/pricing.service";
import {ProductWithRelations} from "@aparraga/ahoracrypto-api-sdk/sdk";
import {Order} from "../domain/order";
import {OrderLine} from "../domain/orderline";
import {ENVIRONMENT, IS_BROWSER} from "../utils/injectiontokens";

declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class EventsTrackerService {

  public constructor(protected pricingService: PricingService,
                     @Inject(IS_BROWSER) protected isBrowser: boolean,
                     @Inject(ENVIRONMENT) protected environment: any) {}

  public trackPageView(pageUrl: string) {
    if(this.isBrowser && this.environment.production) {
      gtag('config', this.environment.gaTrackingId, {'page_path': pageUrl});
    }
  }

  public trackShare(socialNetwork: string) {
    if(this.isBrowser && this.environment.production) {
      gtag('event', 'share', {method: socialNetwork});
    }
  }

  public trackViewSearchResults(searchTerm: string) {
    if(this.isBrowser && this.environment.production) {
      gtag('event', 'view_search_results', {search_term: searchTerm});
    }
  }

  public trackException(message: string) {
    if(this.isBrowser && this.environment.production) {
       gtag('event', 'exception', {
         'description': message,
         'fatal': false,
        'non_interaction': true
      });
    }
  }

  public trackProductListImpression(productList, listName) {

    if(this.isBrowser && this.environment.production) {

      let items = [];
      let position = 1;
      productList.forEach((product: ProductWithRelations) => {

        let gtagProduct = this.transformProductToGtagProduct(product);
        gtagProduct['list_position'] = position;
        gtagProduct['list_name'] = listName;

        items.push(gtagProduct);

        position++;
      });

        gtag('event', 'view_item_list', {
         "items": items,
         'non_interaction': true
       });
    }

  }


  public trackProductDetailImpression(product: ProductWithRelations) {

    if(this.isBrowser && this.environment.production) {

      //facebook pixel event
      /*
      fbq('track', 'ViewContent', {
          value: sku.priceWithTaxes,
          currency: sku.currency,
          content_ids: sku._id,
          content_type: 'product',
      });
       */

      let gtagProduct = this.transformSkuToGtagProduct(product);
      gtagProduct['list_position'] = 1;
      gtagProduct['list_name'] = 'Product detail';

       gtag('event', 'view_item', {
         "items": [
           gtagProduct
        ],
        'non_interaction': true
      });

    }

  }

  public trackAddToCart(product: ProductWithRelations, quantity: number = 1) {

    if(this.isBrowser && this.environment.production) {

      let gtagSku = this.transformSkuToGtagProduct(product);
      gtagSku['list_position'] = 1;
      gtagSku['list_name'] = 'Cart';
      gtagSku['quantity'] = quantity;

      gtag('event', 'add_to_cart', {
        "items": [
         gtagSku
       ]
      });

    }

  }

  public trackRemoveFromCart(product: ProductWithRelations, quantity: number = 1) {

    if(this.isBrowser && this.environment.production) {

      let gtagSku = this.transformSkuToGtagProduct(product);
      gtagSku['list_position'] = 1;
      gtagSku['list_name'] = 'Cart';
      gtagSku['quantity'] = quantity;

         gtag('event', 'remove_from_cart', {
        "items": [
           gtagSku
         ]
       });
    }

  }

  public trackBeginCheckout(order: Order) {

    if(this.isBrowser && this.environment.production) {

      let items = [];

      let position = 1;
      order.orderLines.forEach((orderLine: OrderLine) => {

        let gtagProduct = this.transformSkuToGtagProduct(orderLine.product);
        gtagProduct['list_position'] = position;
        gtagProduct['list_name'] = 'Checkout';
        gtagProduct['quantity'] = orderLine.quantity;

        items.push(gtagProduct);

        position++;
      });

         gtag('event', 'begin_checkout', {
         "items": items,
         "coupon": ""
       });

      let totalRevenue = this.pricingService.getOrderTotalWithTaxesAndShippingCost(order);
      let currency = order.currencyIsoCode;

      /*
      fbq('track', 'InitiateCheckout', {
          value: totalRevenue,
          currency: currency,
          contents: this.transformOrderToFbItems(order),
          content_ids: order.orderLines.map((orderLine: OrderLine) => orderLine.sku._id )
      });

       */

    }

  }

  public trackCheckoutProgress(order: Order, stepNumber: number, stepAlias: string) {

    if(this.isBrowser && this.environment.production) {

        gtag('event', 'checkout_progress', {
         "items": this.transformOrderToGtagItems(order),
         "checkout_step": stepNumber,
         "checkout_option": stepAlias
       });

    }

  }

  public trackCheckoutOption(step: number, optionName: string, optionValue: string) {
    if(this.isBrowser && this.environment.production) {

        gtag('event', 'set_checkout_option', {
         "checkout_step": step,
          "checkout_option": optionName,
         "value": optionValue
        });

    }
  }

  public trackPurchase(order: Order) {
    if(this.isBrowser && this.environment.production) {

      let taxes = this.pricingService.getOrderTaxes(order);
      let totalRevenue = this.pricingService.getOrderTotalWithTaxesAndShippingCost(order);
      let currency = order.currencyIsoCode;

      let purchaseData = {
        "transaction_id": order.id,
        "affiliation": order.referral,
        "value": totalRevenue,
        "currency": currency,
        "tax": taxes,
        "coupon": order.couponCode != null?order.couponCode:"",
        "items": this.transformOrderToGtagItems(order)
      };

    }
  }


  protected transformOrderToGtagItems(order: Order) {
    let items = [];
    let position = 1;
    order.orderLines.forEach((orderLine: OrderLine) => {

      let gtagProduct = this.transformSkuToGtagProduct(orderLine.product);
      gtagProduct['list_position'] = position;
      gtagProduct['list_name'] = 'Checkout';
      gtagProduct['quantity'] = orderLine.quantity;

      items.push(gtagProduct);

      position++;
    });

    return items;
  }

  protected transformProductToGtagProduct(product: ProductWithRelations) {

    let gtagProduct = {
      "id": product.id,
      "name": product.name
    };

    return gtagProduct;

  }

  protected transformSkuToGtagProduct(product: ProductWithRelations) {

    let gtagProduct = {
      "id": product.id,
      "name": product.name
    };

    return gtagProduct;

  }


}
